import { Button, makeStyles, tokens } from '@fluentui/react-components';
import { SparkleRegular } from '@fluentui/react-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../config/routes';

const items = [
  { label: '', path: ROUTES.ASSISTANT, icon: <SparkleRegular /> },
  { label: 'Dashboard', path: ROUTES.DASHBOARD },
  { label: 'Clients', path: ROUTES.CLIENTS },
  { label: 'Orders', path: ROUTES.ORDERS },
  { label: 'Catalog', path: ROUTES.CATALOG },
  { label: 'Offers', path: ROUTES.OFFERS },
  { label: 'Settings', path: ROUTES.SETTINGS },
];

const useStyles = makeStyles({
  root: { width: '220px', display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalS, padding: tokens.spacingHorizontalM, borderRight: `1px solid ${tokens.colorNeutralStroke2}`, backgroundColor: tokens.colorNeutralBackground2 },
});

export const AppSidebar = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <aside className={styles.root}>
      {items.map((item) =>
        item.label === '' ? (
          <Button key={item.path} appearance={location.pathname.startsWith(item.path) ? 'primary' : 'subtle'} icon={item.icon} onClick={() => navigate(item.path)} style={{ alignSelf: 'center' }} />
        ) : (
          <Button key={item.path} appearance={location.pathname.startsWith(item.path) ? 'primary' : 'subtle'} onClick={() => navigate(item.path)}>
            {item.label}
          </Button>
        )
      )}
    </aside>
  );
};
